import { Replace } from '@synapex/tools/typescript'
import { type ComponentPropsWithoutRef, forwardRef, ReactNode } from 'react'
import cl from 'clsx'

import classes from './Input2.module.scss'

export type Input2Props = Replace<
    ComponentPropsWithoutRef<'input'>,
    'type' | 'onChange',
    {
        error?: string | boolean
        type?: 'text' | 'email' | 'number' | 'password'
        onChange?: (v: string) => void
        inputClassName?: string
        withClear?: boolean
        slotButton?: ReactNode
        prefix?: string
    }
>
export const Input2 = forwardRef<HTMLInputElement, Input2Props>(function Input2(
    {
        type = 'text',
        maxLength,
        value,
        onChange: onChangeProp,
        withClear,
        slotButton,
        inputClassName,
        className,
        error,
        prefix,
        disabled,
        ...props
    },
    ref
) {
    const onChange: ComponentPropsWithoutRef<'input'>['onChange'] = onChangeProp
        ? maxLength
            ? (e) => {
                  const newValue = e.target.value

                  if (
                      newValue.length <= maxLength ||
                      newValue.length < (value ?? '')?.toString().length
                  ) {
                      onChangeProp(newValue)
                  }
              }
            : (e) => onChangeProp(e.target.value)
        : undefined

    const onClear = onChangeProp ? () => onChangeProp('') : undefined

    const button = withClear ? (
        <button
            type="button"
            onClick={onClear}
            className={classes.clearButton}
            aria-label="Clear input"
        >
            ×
        </button>
    ) : (
        slotButton
    )
    return (
        <div
            className={cl(
                classes.root,
                { [classes.disabled]: disabled },
                className
            )}
        >
            {prefix && <div className={classes.prefix}>{prefix}</div>}
            <input
                {...props}
                {...{ type, onChange, value }}
                ref={ref}
                className={cl(classes.input, inputClassName, {
                    [classes.error]: Boolean(error),
                })}
            />
            {button}
        </div>
    )
})
